import BaseChannel from '@/shared/classes/tv/BaseChannel'
import { ExtendedEpgElement } from '@/types/epg/Epg'

const getChannelPrograms = (
    epgData: ExtendedEpgElement[],
    channel: BaseChannel
) => {
    const selectedChannel = epgData?.find(
        (element) => element.channelId === channel.id
    )

    const programs = selectedChannel?.programs.length
        ? selectedChannel.programs
        : []
    return programs
}

export default getChannelPrograms
